"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgDislikeFilled = function (props) {
    var color = props.color;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("path", { d: "M15.0001 2C15.5524 2 16.0001 2.44772 16.0001 3V15C16.0001 15.5 15.6946 16.3116 15.5001 16.5L11.5585 21.2701C11.0912 21.7374 10.4573 22 9.79636 22C7.94381 22 7.47479 20.0504 8.30328 18.3934L9.5 16H4C2.89543 16 2 15.1046 2 14L2 9.98196C2 9.55053 2.09305 9.12418 2.2728 8.73199L4.5562 3.75003C5.04495 2.68368 6.11037 2 7.2834 2L15.0001 2Z", fill: color }),
        react_1.default.createElement("path", { d: "M20.0001 16C21.1047 16 22.0001 15.1046 22.0001 14L22.0001 4C22.0001 2.89543 21.1047 2 20.0001 2C18.8955 2 18.0001 2.89543 18.0001 4L18.0001 14C18.0001 15.1046 18.8955 16 20.0001 16Z", fill: color })));
};
exports.default = factorySvgIcon_1.default(SvgDislikeFilled);
//# sourceMappingURL=SvgDislikeFilled.js.map